import { useMemo } from 'react'

import type { MonitoringChannel } from '@oneToOne/shared/ws/monitoring'

import { logError } from '@core/logging'
import type { eventWithTime } from '@core/rrweb'
import { useRrwebClientContext, useScreenRecorder } from '@core/rrweb'

/** Sets up screen recorder for live helper. */
export function useLiveHelperScreenRecorder(
  channel: MonitoringChannel | undefined,
) {
  const { rrweb, packer } = useRrwebClientContext()

  const options = useMemo(() => {
    return {
      maskAllInputs: true,
      // inlineImages: true,
      recordCrossOriginIframes: true,
      emit: (event) => {
        try {
          if (rrweb && packer && channel) {
            channel.push('update_monitor', {
              data: packer.pack(event.data as eventWithTime),
              timestamp: event.timestamp.toString(),
              type: event.type,
            })
          }
        } catch (e: unknown) {
          if (e instanceof Error) {
            logError(e)
          }
        }
      },
      sampling: {
        mouseInteraction: false,
        scroll: 150,
        media: 800,
      },
    }
  }, [channel, packer, rrweb])

  useScreenRecorder(options)
}
